import React from 'react';
import { TextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';
import { SparklesFilled } from '@wix/wix-ui-icons-common';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { useSidebarLayoutBase } from '../../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';

import { classes, st } from './AiChatButton.st.css';

export const AiChatButton: React.FC = () => {
  const { toggleAiChatVisibility, isAiChatVisible, isAiChatEnabled } =
    useSidebarLayoutBase();
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();

  if (!isAiChatEnabled || isAiChatVisible) {
    return null;
  }

  return (
    <TextButton
      className={st(classes.root, {
        mobile: isMobile,
      })}
      priority={TextButtonPriority.secondary}
      prefixIcon={<SparklesFilled className={classes.aiChatIcon} />}
      onClick={toggleAiChatVisibility}
    >
      {t('live-site.ai-chat.ask-ai.button')}
    </TextButton>
  );
};
